import Vue from "vue"
export default ({
    state: {
        dialogFilePreviewVisible: false, //附件预览dialog
        filePreviewUrl:'',//附件预览url地址
        filePreviewTitle:'',
        size:{
           height:null,
           width:null
        }
    },
    mutations: {
        setDialogFilePreviewVisible(state, dialogVisible){
            state.dialogFilePreviewVisible = dialogVisible;
        },
        setFilePreview(state, info){
            state.filePreviewTitle=info.title;
            state.dialogFilePreviewVisible = info.dialogVisible;
            if(info.isPatient){
                state.filePreviewUrl = info.url;
                return false
            }
            if(info.isPreview){
                state.filePreviewUrl= Vue.prototype.OnlinePreview+encodeURIComponent(info.url.replace(/\\/g, '/'))

            }else{
                state.filePreviewUrl= Vue.prototype.OnlinePreview+encodeURIComponent(Vue.prototype.File_ROOT+info.url.replace(/\\/g, '/'))

            }
        },
        setWindowSize(state,info){
            state.size = info
        }
    }
  });